import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';
// eslint-disable-next-line import/no-cycle
import { CreatePersonalAssetHistoryDto, UpdatePersonalAssetHistoryDto } from '../../defs/api';
// eslint-disable-next-line import/no-cycle
import { PersonalAssetHistoryStore } from './personal-asset-history-store';
import { PersonalAssetHistoryMobxDto } from '../mobx/dtos/personal-assets/personal-asset-history-mobx-dto';

export class PersonalAssetHistoryDialogStore {
    rootStore: RootStore;

    personalAssetHistoryStore: PersonalAssetHistoryStore;

    createDialogOpened = false;

    updateDialogOpened = false;

    updatingInitialValues?: PersonalAssetHistoryMobxDto;

    loading = false;

    constructor(personalAssetHistoryStore: PersonalAssetHistoryStore) {
        this.rootStore = personalAssetHistoryStore.rootStore;
        this.personalAssetHistoryStore = personalAssetHistoryStore;

        makeAutoObservable(this, {
            rootStore: false,
            personalAssetHistoryStore: false,
        });
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }

    async create(data: CreatePersonalAssetHistoryDto): Promise<void> {
        try {
            this.startLoading();
            await this.rootStore.apiClient.personalAssetsHistoryApi.personalAssetHistoryControllerCreate({
                createPersonalAssetHistoryDto: data,
            });
            await this.personalAssetHistoryStore.fetchPersonalAsset(data.personalAssetId);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            this.rootStore.alertStore.setErrorMessageByStatus(e.message);
        } finally {
            this.stopLoading();
        }

        this.closeCreateDialog();
    }

    async update(data: UpdatePersonalAssetHistoryDto): Promise<void> {
        if (this.updatingInitialValues) {
            try {
                this.startLoading();
                await this.rootStore.apiClient.personalAssetsHistoryApi.personalAssetHistoryControllerUpdate({
                    updatePersonalAssetHistoryDto: data,
                    id: this.updatingInitialValues.id,
                });
                await this.personalAssetHistoryStore.fetchPersonalAsset(this.updatingInitialValues.personalAssetId);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                this.rootStore.alertStore.setErrorMessageByStatus(e.message);
            } finally {
                this.stopLoading();
            }

            this.closeCreateDialog();
        }
    }

    openCreateDialog(): void {
        this.rootStore.alertStore.setModalPlacement();
        this.createDialogOpened = true;
    }

    closeCreateDialog(): void {
        this.createDialogOpened = false;
        this.rootStore.alertStore.setDefaultPlacement();
    }

    openUpdateDialog(updatingInitialValues: PersonalAssetHistoryMobxDto): void {
        this.updatingInitialValues = updatingInitialValues;
        this.rootStore.alertStore.setModalPlacement();
        this.updateDialogOpened = true;
    }

    closeUpdateDialog(): void {
        this.updateDialogOpened = false;
        this.updatingInitialValues = undefined;
        this.rootStore.alertStore.setDefaultPlacement();
    }
}
